import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

import { Link } from 'react-router-dom';
import Layout from '../layout';

import styles from '../styles/pages/coming-soon.scss';
import APP_ROUTES from '../../constants/app-routes';

class RegisterConfirmation extends Component {
    constructor(props) {
        super(props);

        this.state = {
            registered: false,
            loading: true,
            message: '',
        };

        document.title = this.props.intl.formatMessage({ id: 'register-confirmation', defaultMessage: 'Confirmation of registration' });
    }

    async componentDidMount() {
        const { token } = this.props.match.params;
        this.props.checkregistration(token, this.props.locale).then(
            () => {
                this.setState({
                    registered: true,
                    loading: false,
                    message: '',
                });
            },
        ).catch((error) => {
            this.setState({
                loading: false,
                message: error.response.body.error,
            });
        });
    }

    componentDidUpdate(prevProps) {
        if (this.props.locale !== prevProps.locale) {
            document.title = this.props.intl.formatMessage({ id: 'register-confirmation', defaultMessage: 'Confirmation of registration' });
        }
    }

    render() {
        const { registered } = this.state;
        const registerMessage = (
            <div
                className={styles.comingContainer}
            >
                <h1
                    className={styles.mainText}
                >
                    <FormattedMessage
                        id="registed-message"
                        defaultMessage="You have successfully registered"
                    />
                </h1>
                <Link
                    to={APP_ROUTES.mercadoUnicoProducts}
                    className={styles.buttonLink}
                >
                    <FormattedMessage
                        id="coming-soon-button"
                        defaultMessage="See Mercado Unico Products"
                    />
                </Link>
                <Link
                    to={APP_ROUTES.signin}
                    className={styles.buttonLink}
                >
                    <FormattedMessage
                        id="signin"
                        defaultMessage="Sign In"
                    />
                </Link>
            </div>
        );
        const unregisterMessage = (
            <div
                className={styles.comingContainer}
            >
                <h1
                    className={styles.mainText}
                >
                    {this.state.message}
                </h1>
            </div>
        );

        return (
            <div>

                {
                    this.state.loading ? (
                        <p />
                    ) : (
                        <Layout>

                            {registered ? (
                                registerMessage
                            ) : (
                                unregisterMessage
                            )}

                        </Layout>
                    )
                }
            </div>

        );
    }
}

export default injectIntl(RegisterConfirmation);



/** WEBPACK FOOTER **
 ** ./src/components/pages/register-confirmation.jsx
 **/